export type CadFormDefinition = FieldDefinition[];

export type FieldDefinitionDTO = {
  label: string;
  symbol: string;
  type: string;
  valuesFieldGrid: {
    index: string;
    label: string;
    selected: string;
    value: string;
    helpLabel?: string;
  }[];
};

export type FieldDefinition = Omit<FieldDefinitionDTO, "type"> & {
  type: CadFormFieldType;
};

export function transformCadFieldDefinition(dto: FieldDefinitionDTO): FieldDefinition {
  return {
    ...dto,
    type: getCadFormFieldType(dto.type),
  };
}

export function getCadFormFieldType(type: string): CadFormFieldType {
  return CAD_FORM_FIELD_TYPE_MAPPING[type as keyof typeof CAD_FORM_FIELD_TYPE_MAPPING] ?? CadFormFieldType.Text;
}

export const CadFormFieldType = {
  Select: 0,
  Text: 1,
  Number: 2,
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare -- intentionally naming the variable the same as the type
export type CadFormFieldType = (typeof CadFormFieldType)[keyof typeof CadFormFieldType];

const CAD_FORM_FIELD_TYPE_MAPPING = {
  eFormatTypeBox: CadFormFieldType.Select,
  eFormatTypeText: CadFormFieldType.Text,
  eFormatTypeReal: CadFormFieldType.Number,
  eFormatTypeInteger: CadFormFieldType.Number,
} as const;
